import React, { useState, useEffect } from "react";
import styles from "./InvoicesMobile.module.css";
import { NavLink, useNavigate } from "react-router-dom";
import axios from "axios";

import invoiceimg from "../../assets/images/invoices.png";
import logo from "../../assets/images/logo.png";
import invoiceLogo from "../../assets/icons/invoiceLogo.png";
import backbutton from "../../assets/icons/backbutton.png";
import { useAuth } from "../../context/auth";
import FooterMobile from "../FooterMobile/FooterMobile";

const InvoicesMobile = () => {
  const MAIN_URL = process.env.REACT_APP_URL

  const { user = {} } = useAuth();

  // TO GET ALL INVOICES
  const [invoices, setInvoices] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchInvoices = async () => {
      try {
        const token = localStorage.getItem("token");
        const config = {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        };
        const response = await axios.get(
          `${MAIN_URL}/api/invoice/getAllInvoices`,
          config
        );
        setInvoices(response.data);
      } catch (error) {
        console.error("Error fetching invoices:", error);
      }
    };

    fetchInvoices();
  }, []);

  const handleViewInvoice = (id) => {
    navigate(`/singleInvoice/${id}`);
  };

  return (
    <>
      <div className={styles.invoices_page}>
        {/* <Navbar /> */}
        <div className={styles.invoice_headContainer}>
          <img className={styles.header_image} src={logo} alt="logo " />
          <div className={styles.header_text}>Musicart</div>
        </div>
        <div className={styles.invoice_mainContainer}>
          {/* BACK BUTTON  */}
          <div className={styles.product_back_btn}>
            <NavLink to="/home">
              <button className={styles.back_btn}>
                {" "}
                <img src={backbutton} alt="" />
              </button>
            </NavLink>
          </div>

          {/* HEADING */}
          <div className={styles.main_heading}>
            <img src={invoiceLogo} alt="invoiceLogo" />
            <div> My Invoices</div>
          </div>

          {invoices.map((invoice) => (
            <div className={styles.content}>
              <div key={invoice._id} className={styles.invoice_container}>
                <div className={styles.left_section}>
                  <img src={invoiceimg} alt="invoiceimg" />
                  <div className={styles.details_section}>
                    <p className={styles.user_name}>{user.name}</p>
                    <p className={styles.user_address}>{invoice.address}</p>
                  </div>
                </div>
                <div className={styles.right_section}>
                  <button
                    onClick={() =>
                      handleViewInvoice(invoice._id, invoice.address)
                    }
                  >
                    View Invoice
                  </button>
                </div>
              </div>
              <div className={styles.line}></div>
            </div>
          ))}
        </div>

        <FooterMobile />
      </div>
    </>
  );
};

export default InvoicesMobile;
